import { v4 as uuidv4 } from 'uuid';

import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { Submenu } from '../../../../vtex-apps/menu/Submenu/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

const StoreMenuDesktop = () => {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'StoreMenuDesktop',
		componentId: uuidv4(),
		variables,
		props: FlexLayoutRow({ colSizing: 'equal', blockClass: 'menu-desk-1__row' }).props,
		childrenComponents: [
			FlexLayoutCol({}, [
				Menu({ blockClass: 'menu-desk-1__menu', mzTitle: 'MZ | Menu' }, [
					VisibilityLayout({ mzTitle: 'MZ | Menu Item (On/Off)' }, [
						MenuItem(
							{
								id: 'menu-desk-1-1-item',
								blockClass: 'menu-desk-1__menu-item',
								mzTitle: 'MZ | Menu Item',
							},
							[],
							[
								Submenu({ blockClass: 'menu-desk-1__submenu' }, [
									Menu({
										orientation: 'vertical',
										blockClass: 'menu-desk-1__submenu',
										items: [
											MenuItem({ id: 'menu-desk-1-subitem-1' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-2' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-3' }).props,
										],
									}),
								]),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Menu Item (On/Off)' }, [
						MenuItem(
							{
								id: 'menu-desk-1-2-item',
								blockClass: 'menu-desk-1__menu-item',
								mzTitle: 'MZ | Menu Item',
							},
							[],
							[
								Submenu({ blockClass: 'menu-desk-1__submenu' }, [
									Menu({
										orientation: 'vertical',
										blockClass: 'menu-desk-1__submenu',
										items: [
											MenuItem({ id: 'menu-desk-1-subitem-1' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-2' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-3' }).props,
										],
									}),
								]),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Menu Item (On/Off)' }, [
						MenuItem(
							{
								id: 'menu-desk-1-3-item',
								blockClass: 'menu-desk-1__menu-item',
								mzTitle: 'MZ | Menu Item',
							},
							[],
							[
								Submenu({ blockClass: 'menu-desk-1__submenu' }, [
									Menu({
										orientation: 'vertical',
										blockClass: 'menu-desk-1__submenu',
										items: [
											MenuItem({ id: 'menu-desk-1-subitem-1' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-2' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-3' }).props,
										],
									}),
								]),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Menu Item (On/Off)' }, [
						MenuItem(
							{
								id: 'menu-desk-1-4-item',
								blockClass: 'menu-desk-1__menu-item',
								mzTitle: 'MZ | Menu Item',
							},
							[],
							[
								Submenu({ blockClass: 'menu-desk-1__submenu' }, [
									Menu({
										orientation: 'vertical',
										blockClass: 'menu-desk-1__submenu',
										items: [
											MenuItem({ id: 'menu-desk-1-subitem-1' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-2' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-3' }).props,
										],
									}),
								]),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Menu Item (On/Off)' }, [
						MenuItem(
							{
								id: 'menu-desk-1-5-item',
								blockClass: 'menu-desk-1__menu-item',
								mzTitle: 'MZ | Menu Item',
							},
							[],
							[
								Submenu({ blockClass: 'menu-desk-1__submenu' }, [
									Menu({
										orientation: 'vertical',
										blockClass: 'menu-desk-1__submenu',
										items: [
											MenuItem({ id: 'menu-desk-1-subitem-1' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-2' }).props,
											MenuItem({ id: 'menu-desk-1-subitem-3' }).props,
										],
									}),
								]),
							],
						),
					]),
					MenuItem(
						{ id: 'menu-desk-1-6-item', blockClass: 'menu-desk-1__menu-item', mzTitle: 'MZ | Menu Item' },
						[],
						[
							Submenu({ blockClass: 'menu-desk-1__submenu' }, [
								Menu({
									orientation: 'vertical',
									blockClass: 'menu-desk-1__submenu',
									items: [
										MenuItem({ id: 'menu-desk-1-subitem-1' }).props,
										MenuItem({ id: 'menu-desk-1-subitem-2' }).props,
										MenuItem({ id: 'menu-desk-1-subitem-3' }).props,
									],
								}),
							]),
						],
					),
					MenuItem(
						{ id: 'menu-desk-1-7-item', blockClass: 'menu-desk-1__menu-item', mzTitle: 'MZ | Menu Item' },
						[],
						[
							Submenu({ blockClass: 'menu-desk-1__submenu' }, [
								Menu({
									orientation: 'vertical',
									blockClass: 'menu-desk-1__submenu',
									items: [
										MenuItem({ id: 'menu-desk-1-subitem-1' }).props,
										MenuItem({ id: 'menu-desk-1-subitem-2' }).props,
										MenuItem({ id: 'menu-desk-1-subitem-3' }).props,
									],
								}),
							]),
						],
					),
					MenuItem(
						{ id: 'menu-desk-1-8-item', blockClass: 'menu-desk-1__menu-item', mzTitle: 'MZ | Menu Item' },
						[],
						[
							Submenu({ blockClass: 'menu-desk-1__submenu' }, [
								Menu({
									orientation: 'vertical',
									blockClass: 'menu-desk-1__submenu',
									items: [
										MenuItem({
											id: 'menu-desk-1-subitem-1',
											blockClass: 'menu-desk-1__submenu-item',
										}),
										MenuItem({
											id: 'menu-desk-1-subitem-2',
											blockClass: 'menu-desk-1__submenu-item',
										}),
										MenuItem({
											id: 'menu-desk-1-subitem-3',
											blockClass: 'menu-desk-1__submenu-item',
										}),
									],
								}),
							]),
						],
					),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--menu-desktop-1-menu-bg-color', name: 'Menu Background' },
			{ from: '--text-color-1-dark', to: '--menu-desktop-1-menu-text-color', name: 'Menu Text' },
			//menu text hover
			{ from: '--text-color-1-light', to: '--menu-desktop-1-menu-text-hover-color', name: 'Menu Text Hover' },
			{
				from: '--text-color-1-dark',
				to: '--menu-desktop-1-categories-border-color',
				name: 'All Categories Border',
			},
			//submenu text color
			{ from: '--text-color-1-dark', to: '--menu-desktop-1-submenu-text-color', name: 'Submenu Text' },
			//submenu
			{ from: '--white', to: '--menu-desktop-1-submenu-bg-color', name: 'Submenu Background' },

			//submenu border color
			{ from: '--text-color-1-dark', to: '--menu-desktop-1-submenu-border-color', name: 'Submenu Border' },
			//submenu item hover
			{
				from: '--neutral-color-high-medium',
				to: '--menu-desktop-1-submenu-item-hover-color',
				name: 'Submenu Item Hover',
			},
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--menu-desktop-1-border-radius', name: 'Border Radius' },
			{ from: '--border-radius-sm', to: '--menu-desktop-1-submenu-br', name: 'Submenu' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--menu-desktop-1-main-size', name: 'Main font Size' },
			//submenu text size
			{ from: '--font-size-xs', to: '--menu-desktop-1-submenu-fs', name: 'Submenu' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--menu-desktop-1-menu-weight', name: 'Menu font weight' },
			//submenu
			{ from: '--font-weight-400', to: '--menu-desktop-1-submenu-fw', name: 'Submenu' },
		],
	},
	//borderWidth
	{
		type: 'borderWidth',
		list: [{ from: '--border-width-hairline', to: '--menu-desktop-1-border-width', name: 'Border Width' }],
	},
	{
		type: 'spacing',
		list: [
			//menu height
			{ from: '--spacing-nano', to: '--menu-desktop-1-menu-height', name: 'Menu Height' },
			{ from: '--spacing-atom', to: '--menu-desktop-1-submenu-gap', name: 'Submenu Items Gap' },
			//submenu lateral padding
			{ from: '--spacing-sm', to: '--menu-desktop-1-submenu-lateral-padding', name: 'Submenu Lateral Padding' },
		],
	},
];

export default StoreMenuDesktop;
